"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _1 = require("./");
var inversify_1 = require("inversify");
var Root = /** @class */ (function () {
    function Root(profile, company, organization, skill, language) {
        this.profile = profile;
        this.company = company;
        this.organization = organization;
        this.skill = skill;
        this.language = language;
    }
    var _a, _b, _c, _d, _e;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CompanyClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.OrganizationClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.SkillClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.LanguageClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileClient !== "undefined" && _1.UserProfileClient) === "function" ? _a : Object, typeof (_b = typeof _1.CompanyClient !== "undefined" && _1.CompanyClient) === "function" ? _b : Object, typeof (_c = typeof _1.OrganizationClient !== "undefined" && _1.OrganizationClient) === "function" ? _c : Object, typeof (_d = typeof _1.SkillClient !== "undefined" && _1.SkillClient) === "function" ? _d : Object, typeof (_e = typeof _1.LanguageClient !== "undefined" && _1.LanguageClient) === "function" ? _e : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;
